
import PropTypes from "prop-types";
import React from "react";
import { useReducer } from "react";
import "./style.css";
import { useState } from 'react';

export const InputCode = ({
  stateProp,
  className,
  iconPerson = "/img/icon-person-4.png",
  text = "Campo de texto",
  onInputChange,
}) => {

  const [user, setUser] = useState('');

  const [state, dispatch] = useReducer(reducer, {
    state: stateProp || "default",
  });

  return (
    <div
      className={`input-contrase-a ${state.state} ${className}`}
      onMouseEnter={() => {
        dispatch("mouse_enter");
      }}
      onClick={() => {
        dispatch("click");
      }}
      onMouseLeave={() => {
        dispatch("mouse_leave");
      }}
    >
      {/*{["default", "hover"].includes(state.state) && (
        <img
          className="icon-person"
          alt="Icon person"
          src={state.state === "hover" ? "/img/icon-person-3.png" : iconPerson}
        />
      )}*/}

      <div className="campo-de-texto">

        {["default", "hover"].includes(state.state) && <>{text}</>}
        <input className="entrada-de-texto"
          type={'number'}
          value={user}
          onChange={(e) => {
              const user = e.target.value;
              setUser(user);
              onInputChange(user);
              }
            }
          onFocus={(e) => {
            e.target.click();
            }
          }
          onBlur={(e) => {
            if (e.target.value === "") {
              dispatch("empty");
            }
            
            }
          }
          />

      </div>
    </div>
  );
};

function reducer(state, action) {
  if (action === "empty") {
    return {
          state: "default",
        };
  }

  if (state.state === "default") {
    switch (action) {
      case "mouse_enter":
        return {
          state: "hover",
        };
      case "click":
        return {
          state: "active-hidden",
      };
    }
  }

  if (state.state === "hover") {
    switch (action) {
      case "mouse_leave":
        return {
          state: "default",
        };

      case "click":
        return {
          state: "active-hidden",
        };
    }
  }

  return state;
}

InputCode.propTypes = {
  stateProp: PropTypes.oneOf(["active-hidden", "hover", "error", "default"]),
  iconPerson: PropTypes.string,
  text: PropTypes.string,
};
